import { Button } from "@material-ui/core";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import FullscreenContext from "../../FullscreenContext";
import { setFullScreen } from "../../redux/actions/uxActions";
import { ApplicationData, ClientPhase } from "../../types";
import SessionTabs from "./SessionTabs";
import { Localizations } from "../../../Shared/sharedTypes";

const mapState = ({ fullscreen, liveSwitchState }: ApplicationData) => ({
    fullscreen,
    connected: liveSwitchState.clientRegistered,
});

const mapDispatch = { setFullScreen };

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & { setPhase: (phase: ClientPhase) => void; localizations: Localizations };

function SessionPage({ setPhase, setFullScreen, fullscreen, connected, localizations }: PropTypes) {
    const { Modernizr } = window as any;

    return (
        <FullscreenContext.Consumer>
            {(fullScreenRef) => (
                <>
                    <SessionTabs
                        setPhase={setPhase}
                        fullScreenContainer={fullScreenRef!}
                        setFullScreen={(fullScreen: boolean) => setFullScreen(fullScreen)}
                    ></SessionTabs>
                    {Modernizr.fullscreen && !fullscreen && (
                        <Button
                            size="large"
                            variant="contained"
                            onClick={() => setFullScreen(true)}
                            color="primary"
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                marginTop: -40,
                                zIndex: 500,
                                marginLeft: -70,
                            }}
                        >
                            {localizations.goFullScreen}
                        </Button>
                    )}
                    {!connected && (
                        <div className="connectionCurtain">
                            <span>
                                {localizations.attemptingToConnect}
                                <br />
                                <span style={{ fontSize: ".7em" }}>
                                    <i>{localizations.pleaseCheckYourInternetConnection}</i>
                                </span>
                            </span>
                        </div>
                    )}
                </>
            )}
        </FullscreenContext.Consumer>
    );
}

export default connector(SessionPage);
